<ng-container>
    <div class="container">
        <div class="d-flex justify-content-between">
            <div>
                <h4 class=" float-left getstartedtext" style="font-size: 16px;">Sorry, I did not catch your name</h4>
            </div>
            <div style="margin-top: 17px;">
                <img src="../../../assets/img/close.svg" alt="" (click)="closeModal();close_popup()"> 
            </div>
        </div>

        <form [formGroup]="getProfileForm" autocomplete="off">
            <div class="input-group" style="padding-bottom: 25px;">
                <input id="fileInput" type='text' formControlName="userName" name="name" autocomplete="off"
                    placeholder="Enter your name" style="width: 68% !important;">
                <span class="input-group-btn">
                    <button class="btn-getotp-next" [disabled]="!getProfileForm.valid"
                        (click)="updateUserProfile()">Next</button>
                </span>
            </div>
        </form>
    </div>
</ng-container>

<style>
    .text-center {
        margin-bottom: 10px !important;
        font-size: 25px;
        font-family: helvetica nue;
        color: gray;
    }

    .text-center_second {
        margin-bottom: 10px !important;
        font-size: 18px;
        color: #463f3f;
    }

    .form_text {
        margin-bottom: 10px !important;
        font-size: 16px !important;
        font-family: helvetica nue;
        color: gray;
        line-height: 2.3;
    }

    .form_text p span {
        color: #278e1b !important;
    }

    .form_field {
        font-size: 16px !important;
        font-family: helvetica nue;
    }

    .term_text span {
        font-size: 12px;
        color: #479943 !important;
        font-family: Roboto;
    }

    .term_text p {
        font-size: 12px;
        font-family: Roboto;
        width: 102%;
    }

    button {
        background-color: #479943;
        color: #ffff;
        justify-content: center;
        align-items: center;

    }

    @media only screen and (min-width: 600px) {
        .container {
            width: 424px;
            max-width: 100%;

        }

    }

    .container {
        position: relative;
        margin-left: auto;
        margin-right: auto;
        padding-right: 11px;
        padding-left: 11px;
        margin-top: -10px;
    }

    /* .container p{
                font-size: 13px;
                font-family: helvetica nue;
            } */
    .imagecookie {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        overflow: hidden;
        position: absolute;
        top: -30px;
        left: calc(50% - 50px);
        margin-left: 20px;
    }

    ::ng-deep .mat-bottom-sheet-container {
        padding: 8px 16px;
        min-width: 100vw;
        /* min-width: 512px;
  max-width: calc(100vw - 256px) !important; */
        box-sizing: border-box;
        display: block;
        outline: 0;
        overflow: auto;
        border-top-left-radius: 16px !important;
        border-top-right-radius: 16px !important;
    }

    ::ng-deep .mat-bottom-sheet-container-large {
        min-width: 380px;
        max-width: 380px;
    }

    ::ng-deep.mat-bottom-sheet-container-xlarge {
        min-width: 380px;
        max-width: 380px;
    }

    @media only screen and (max-width: 1365px) {
        ::ng-deep .mat-bottom-sheet-container-large {
            min-width: 380px;
            max-width: 380px;
        }

    }


    .actions button {
        /* background-image: linear-gradient(to right, #62AF55, #4AB07F);
         */
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: helvetica nue;
        height: 30px;
        width: 230px;
        color: #ffff;
        font-weight: 600;
        margin: 9px;
    }

    .btn-getotp {
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: Roboto;
        height: 40px;
        color: #ffff;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 0.8px;
        border: none;
        border-radius: 0px 5px 5px 0px;

    }

    .btn-getotp-next {
        background: linear-gradient(to right, #62AF55, #4AB07F);
        font-family: Roboto;
        height: 40px;
        color: #ffff;
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 0.8px;
        border: none;
        border-radius: 0px 5px 5px 0px;
        width: 95px;
        line-height: 19px;
    }

    button[disabled] {
        opacity: 0.9;
        cursor: not-allowed !important;
    }

    .getstartedtext {
        font-family:Roboto;
        font-size: 18px;
        letter-spacing: 0.04px;
        line-height: 23px;
        font-weight: 450;
    }

    .actions img {
        margin: 10px !important;
    }

    .actions p {
        margin-top: 9px;
        text-align: center;
        font-size: 14px;
        color: #479943 !important;
        font-family: helvetica nue;
    }

    .actions_span {
        padding: 10px !important;
        color: gray;
    }

    #fileInput {
        align-items: center;
        background: #ebebeb;
        border: 1px solid #ebebeb;
        /* margin-top: 20px; */
        cursor: text;
        display: flex;
        font-family: Roboto;
        height: 40px !important;
        outline: none;
        padding: 0 1.42857143rem;
        padding: 0 calc(1.42857143rem - .2em);
        position: relative;
        transition: background 0.2s ease-in-out, border 0.2s ease-in-out, box-shadow 0.2s ease-in-out, color 0.2s ease-in-out;
        will-change: background, border, box-shadow, color;
        width: 75%;
        border-radius: 5px 0px 0px 5px;
        caret-color: #25cb7d;
    }

    :host ::ng-deep .otp-input {

        height: 60px !important;
        width: 60px !important;
    }

    .mail_stored {
        width: 367px;
    }

    .invalidOTP {
        color: #FA4747;
        margin-left: 10px;
    }

    ::ng-deep.otp-input:focus-visible {
        outline: 1px solid #25cb7d !important;
    }

    ::ng-deep.otp-input {
        border: 1px solid #25cb7d !important;
        border-radius: 8px !important;
    }
</style>